var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 5.91683H5.66683V9.25016C5.66683 9.61683 5.36683 9.91683 5.00016 9.91683C4.6335 9.91683 4.3335 9.61683 4.3335 9.25016V5.91683H1.00016C0.633496 5.91683 0.333496 5.61683 0.333496 5.25016C0.333496 4.8835 0.633496 4.5835 1.00016 4.5835H4.3335V1.25016C4.3335 0.883496 4.6335 0.583496 5.00016 0.583496C5.36683 0.583496 5.66683 0.883496 5.66683 1.25016V4.5835H9.00016C9.36683 4.5835 9.66683 4.8835 9.66683 5.25016C9.66683 5.61683 9.36683 5.91683 9.00016 5.91683Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusDark);
export default __webpack_public_path__ + "static/media/icon-plus-dark.90cbbf8f9444a8176b15433cf0f5b945.svg";
export { ForwardRef as ReactComponent };